import { FC } from "react";

export const RegistrationDateDisclosureNotice: FC = () => (
  <p className="small text-muted mb-0 mt-3">
    Når de indtastede oplysninger sendes til Advokatsamfundet, registreres de
    efterfølgende i Advokatsamfundets register.{" "}
    <strong>
      Oplysningerne bliver efterfølgende gjort tilgængelige i Advokatnøglen.
    </strong>{" "}
    Indsender du fx denne blanket den 1/1 og oplyser, at driftsdatoen,
    ændringsdatoen eller ophørsdatoen er den 15/1, vil oplysningerne blive
    offentligt tilgængelige via Advokatnøglen umiddelbart efter denne datos
    indtræden.
  </p>
);
